import navBarHomepage from '../modules/navbar-homepage';
import config from '../config';

let collectionController = () => {
    require('../modules/custom-content-manager')();
    navBarHomepage.on();
    if (config.get('featureFlags.pollsEnabled') === true) {
        require('../modules/collection_poll')();
    }
};

export default collectionController;
